<template>
  <v-container fluid :class="this.$vuetify.theme.dark ? '' : 'grey lighten-4'">
    <v-row align="center" justify="center" class="table-cell">
      <v-col cols="12" md="5" sm="12" class=" ">
        <v-card elevation="0" class="mx-auto pa-3">
          <v-form v-model="valid" ref="form">
            <v-card-title
              ><h1>
                {{ $t("auth.login.title") }}
                <span style="color: orange"> Quick delivery system</span>
              </h1></v-card-title
            >
            <v-text-field
              v-model="username"
              outlined
              :rules="[rules.required, rules.emailMatch]"
              prepend-icon="mdi-account"
              :label="$t('auth.login.number')"
              required
            ></v-text-field>
            <v-text-field
              outlined
              v-model="password"
              :rules="[rules.required, rules.min_password]"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :label="$t('auth.login.password')"
              required
              @keydown.enter="login"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-form>
          <v-btn
            color="primary"
            block
            :disabled="loading || !valid"
            @click="login()"
            :loading="loading"
            class="mb-3"
          >
            {{ $t("auth.login.btn") }}
          </v-btn>
          <v-btn color="primary" block to="/rest-password" outlined>
            Reset password ?
          </v-btn>
          <v-btn color="green" block href="https://quickdeliverysystem.com/register" class="mt-2" outlined>
            Don't have account ? register now !!
          </v-btn>
          <span class="mt-2" v-if="errorMessages" style="color: red">{{
            errorMessages
          }}</span>
        </v-card>
      </v-col> </v-row
    ><v-row align="center" justify="center" class="table-cell">
      <v-col cols="12" md="8" sm="12" class="ma-0 pa-0">
        <blog />
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="table-cell">
      <footerTop class="ma-0 text--center" />
      <siteFooter class="ma-0" />
    </v-row>
  </v-container>
</template>
<script>
import blog from "../pages/blog/index.vue";
import siteFooter from "../components/siteFooter.vue";
import footerTop from "../components/footerTop.vue";
import { mapGetters } from "vuex";
export default {
  name: "login",
  components: { blog ,siteFooter,footerTop},
  data() {
    return {
      rules: {
        required: null,
        min_password: null,
        emailMatch: null,
      },
      username: "",
      password: "",
      showPassword: false,
      loading: false,
      valid: true,
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.min_password = (v) =>
      v.length >= 6 || this.$t("rules.min_password");
    this.rules.emailMatch = (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      this.$t("rules.emailMatch");
  },
  computed: {
    ...mapGetters("alert",["errorMessages"]),
  },
  updated() {
    this.$refs.form.validate();
  },
  methods: {
    login() {
      this.$refs.form.validate();
      if (this.valid == false || this.loading == true) return;
      this.loading = true;
      let data = {
        email: this.username,
        password: this.password,
        role: 0,
      };

      // set before login to false
      this.$store
        .dispatch("users/login", data)
        .then((res) => {
          // this.$router.push("/app/package");
          window.location.reload();
        })
        .catch(() => {
          this.loading = false;
        });
      //this.loading = false;
    },
  },
};
</script>

<style>
.background {
  background-position: bottom; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
}
</style>
